import axios from 'axios';
import { API_URL } from 'config.jsx';
import moment from 'moment';

const formatResponse = (response) => {
  const items = response.data.results;
  items.forEach((item) => {
    item.date = moment(item.date);
  });
  return {
    items,
    year: response.data.year,
    years: response.data.years,
  };
};

export default async function fetchItems(elephantId, year) {
  const response = await axios.get(`${API_URL}elephants/${elephantId}/eventsandlogbooks/`, {
    params: {
      year: year || null,
    },
  });
  return formatResponse(response);
}



// WEBPACK FOOTER //
// ./src/layout/logbook/fetchItems.js